<template>
  <div class="container unprint" ref="container">
    <div class="row">
      <div class="plugins__title">
        <b>Плагины</b>
      </div>
    </div>
    <div class="row addons">
      <div class="col-lg-4 col-12 col-sm-6 col-md-6 addons__item" v-for="item in links"
           :key="item.id">
        <a :href="item.link" class="addons__link" target="_blank">
          <img src="@/assets/img/cog-red.svg" alt="downlad" class="addons__link-img">
          {{ item.name }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        {
          id: 0,
          name: 'Плагин для Autocad',
          link: 'https://nav.tn.ru/services/bim/klin-20-prilozhenie-dlya-formirovaniya-uklonov-na-ploskoy-krovle-s-pomoshchyu-klinovidnoy-izolyatsii/',
        },
        // {
        //   id: 1,
        //   name: 'Плагин для Revit',
        //   link: 'https://nav.tn.ru/services/bim/klin-10-prilozhenie-dlya-formirovaniya-uklonov-na-ploskoy-krovle-s-pomoshchyu-klinovidnoy-izolyatsii/',
        // },
      ],
    };
  },
  components: {
  },
};
</script>

<style lang="sass" scoped>
  .plugins__title
    font-style: normal
    font-weight: bold
    line-height: rem(22)
    color: $black
    +media((padding: (320: rem(34) rem(24) rem(17), 992: rem(34) 0 rem(17))))
    +media((font-size: (320: rem(16), 992: rem(18))))
  .addons
    &__link
      font-style: normal
      font-weight: 500
      font-size: rem(14)
      line-height: rem(22)
      color: $black
      transition: .5s
      text-decoration: none
      display: flex
      flex-direction: row
      align-items: center
      text-align: left
      padding: 0 rem(28)
      min-height: rem(68)
      &-img
        padding-right: rem(28)
        transition: .5s
      &:hover
        color: $red
        .addons__link-img
          opacity: .7
    &__item
      background: #F6F6F6
      border: rem(1) solid #ECECEC
      box-sizing: border-box
      cursor: pointer
      display: flex
      flex-direction: row
      align-items: center
      padding: 0
</style>
